import { createContext } from 'react';

const departmentsContext = createContext();

export default departmentsContext;